import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    details: {
        accessibility: string;
        hide: string;
        show: string;
    };
    ai: {
        /** Aria label for toggling AI panel */
        accessibility: string;
        /** Label when hiding AI panel */
        hide: string;
        /** Label when showing AI panel */
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            details: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.details.accessibility?c=190q4ea2i1ne2", defaultMessage: "Toggle the asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.details.hide?c=1jj9k48hksw7v", defaultMessage: "Hide Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.details.show?c=p6b76q673edj", defaultMessage: "Show Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** AI panel toggle labels */
            ai: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling AI panel */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.ai.accessibility?c=1umjiqoqq0dlm", defaultMessage: "Toggle the AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding AI panel */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.ai.hide?c=10ebb25ywjma3", defaultMessage: "Hide AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing AI panel */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "viewer.ai.show?c=2gqg8jp2a38j8", defaultMessage: "Show AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
